import fetch from "lib/fetch";
import type { MobileLinkInterface } from "types/reference";

type MobileLinkListResponse = { data: Array<MobileLinkInterface> };

export const getMobileLinksRequest = (languageCode: string) =>
    fetch.get<MobileLinkListResponse>(`reference/mobile_link/${languageCode}`);
